import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import LoginPage from './components/auth/LoginPage';
import DashboardLayout from './components/layout/DashboardLayout';
import UnifiedDashboard from './components/unified/UnifiedDashboard';
import UnifiedVersionCompare from './components/compare/UnifiedVersionCompare';
import MetricDetailPage from './components/metrics/MetricDetailPage';
import UnifiedAlertListPage from './components/alerts/UnifiedAlertListPage';
import UserManagement from './components/admin/UserManagement';
import LoadingSpinner from './components/common/LoadingSpinner';

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      }>
        {/* Unified Dashboard */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <UnifiedDashboard />
          </ProtectedRoute>
        } />
        {/* Version Compare — redesigned */}
        <Route path="/compare" element={
          <ProtectedRoute>
            <UnifiedVersionCompare />
          </ProtectedRoute>
        } />
        <Route path="/metric/:metricKey" element={
          <ProtectedRoute>
            <MetricDetailPage />
          </ProtectedRoute>
        } />
        {/* Alerts — redesigned with slide-in detail panel */}
        <Route path="/alerts" element={
          <ProtectedRoute>
            <UnifiedAlertListPage />
          </ProtectedRoute>
        } />
        <Route path="/admin/users" element={
          <ProtectedRoute roles={['admin']}>
            <UserManagement />
          </ProtectedRoute>
        } />
      </Route>

      {/* Redirects */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/management" element={<Navigate to="/dashboard" replace />} />
      <Route path="/developer" element={<Navigate to="/dashboard" replace />} />
      <Route path="/developer/compare" element={<Navigate to="/compare" replace />} />
      <Route path="/alert/:alertId" element={<Navigate to="/alerts" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
